import { api } from './client'

export type UserLookup = {
  id: number
  name: string
  email: string
  role: string
  avatar_color: string | null
}

export async function lookupUsers(): Promise<UserLookup[]> {
  return api<UserLookup[]>('/lookups/users')
}

export type EpicLookup = { id: number; name: string; color: string | null; status: string }
export type SprintLookup = { id: number; name: string; status: string; start_date: string | null; end_date: string | null }

export async function lookupEpics(projectId: number): Promise<EpicLookup[]> {
  return api<EpicLookup[]>('/lookups/epics', { query: { project_id: projectId } })
}

export async function lookupSprints(projectId: number): Promise<SprintLookup[]> {
  return api<SprintLookup[]>('/lookups/sprints', { query: { project_id: projectId } })
}
